import { Draggable } from "react-beautiful-dnd";
import accept_icon from "../../common/assets/images/accepticon.png";
import delete_icon from "../../common/assets/images/deleteIcon.png";
import codebook_icon from "../../common/assets/images/codeBookHighlight.png";
import eyeIcon from "../../common/assets/images/eyeicon.png"
import source_doc_ref from "../../common/assets/images/sourcedocIcon.png";
import bar_icon from "../../common/assets/images/ThreeLines.png";
import { Dropdown } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { codeReferenceClick } from "./Service";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import achiCodesData from "../CodingScreen/achi_codes.json";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { has } from "lodash";
import { useLocation } from "react-router-dom";
import {
  setClusterIDs,
  setcurrentClusterID,
  setDocumentationCard,
  setIsProcedureCodeCopyModal,
  setNextClusterIDs,
  setProcedureCodeItem,
} from "../pages/Coder/redux/CoderSlicer";
import {
  setActiveIcon,
  setActiveTab,
  updateAcsCode,
  updateNcaCode,
} from "../CodeBook/redux/CodeBookSlicer";
import { setAIJustificationData } from "../DocumentViewer/redux/DocumentViewerSlicer";
// import mockLabels from "./mock";
// import ReferencePopUp from "./ReferencePopUp";

const DraggableItem = ({
  item,
  type,
  index,
  displayNumber,
  accepted,
  // handleAccept,
  handleDelete,
  handleCodebookClick,
  selectedCofValues,
  handleCofSelect,
  codingscreendata,
  iconDisplay,
  newlyInsertedCodes,
  handleAcceptCodes,
  hacStatus,
  drgConfirmedStatusUpdate,
  // nextClusterCurrentIndex,
  diagnosisStates,
  setDiagnosisStates,
  onCofOrClusterChange,
  isSelected
}) => {
  const reduxDispatch = useDispatch();
  //console.log(codingscreendata, accepted, hacStatus,item, "checkedheredrags");

  const isCodingComplete = codingscreendata?.data?.meta?.status?.some(
    (s) =>
      s.status === "Coding Complete" ||
      s.status === "Audited" ||
      s.status === "Awaiting Audit" ||
      s.status === "Audit - Awaiting Audit" ||
      s.status === "For Review" ||
      s.status === "Audit - For Review",
  );
  const isAwaitingValidation = codingscreendata?.data?.meta?.status?.some(
    (s) => s.status === "AI codes awaiting validation",
  );
  // console.log(isCodingComplete, codingscreendata,newlyInsertedCodes,"isCodingComplete");

  const [sourceLoading, setSourceLoading] = useState(false);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const drgConfirmedStatus = codingscreendata?.data?.meta?.status;
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);
  const [open, setOpen] = useState(false);
  const [codeOpen, setCodeOpen] = useState(false);
  // const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const { documentViewerData } = useSelector(
    (state) => state.documentViewer.documentViewer,
  );
  const {
    documentviewerCurrentPage,
    documentviewerSearchValue,
    documentviewerEventKey,
    documentviewerSelectedDocumentData,
    episodeIdentifierTopassDocumentViewer,
  } = useSelector((state) => state.documentViewer);
  const { currentClusterID, clusterIDs, nextClusterIDs } = useSelector(
    (state) => state.coder,
  );
  const { codeBookLoading, selectedCodebookVersion, isFetched12, isFetched13 } =
    useSelector((state) => state.codeBook);
  const { visibleNudgeCount } = useSelector((state) => state.nudging);  
  const location = useLocation();
  const isDCID = codingscreendata?.data?.meta?.is_DCID === true;
  // const [popupData, setPopupData] = useState(null);
  const getReasoningId = (code) => {
    const params = new URLSearchParams(window.location.search);
    const newEpisodeIdentifier = params.get("episode_identifier_number");

    const episode_identifier_to_pass = episodeIdentifierTopassDocumentViewer
      ? episodeIdentifierTopassDocumentViewer
      : newEpisodeIdentifier;

    const documents = documentViewerData?.documents || [];
    const getDocName = (doc) =>
      doc?.document_name
        ?.replace(".txt", "")
        ?.slice(doc?.document_name?.indexOf("-") + 1);

    // Map codes to document names
    const docMap = {
      histopathology: ["2D12.3", "2M8211/0", "2D12.2", "2M8213/0"],
      colonoscopy: ["32093-00"],
      anaesthetic: ["92515-19"],
      patient_clinical: [
        "2D64.9",
        "2R34",
        "2Z86.43",
        "2U83.2",
        "95550-03",
        "95550-02 [1916]",
      ],
      operative_report: ["49518-00", "96233-01"],
      discharge_summary: ["2M17.1"],
    };

    const histopathologyDoc = documents.find(
      (doc) => doc?.document_name === "2COLONOSCOPY-histopathology_report.txt",
    );
    const colonoscopyDoc = documents.find(
      (doc) => doc?.document_name === "2COLONOSCOPY-colonoscopy_report.txt",
    );
    const anaestheticDoc = documents.find(
      (doc) => doc?.document_name === "2COLONOSCOPY-anaesthetic_record.txt",
    );
    const patientClinicalNotesDoc = documents.find(
      (doc) => doc?.document_name === "JOCELINEKNEE-patient_clinical_notes.txt",
    );
    const operativeReportTotalKneeArthroplastyDoc = documents.find(
      (doc) =>
        doc?.document_name ===
        "JOCELINEKNEE-operative_report_total_knee_arthroplasty.txt",
    );
    const dischargeSummaryDoc = documents.find(
      (doc) => doc?.document_name === "JOCELINEKNEE-discharge_summary.txt",
    );

    const data = {
      // eventKey: documentviewerEventKey,
      searchValue: documentviewerSearchValue,
      episode_identifier_number: episode_identifier_to_pass,
      page: documentviewerCurrentPage,
    };
    if (docMap.histopathology.includes(code) && histopathologyDoc) {
      // console.log("Code received:", code);

      data.documentName = getDocName(histopathologyDoc);
      data.eventKey = 73;
    } else if (docMap.colonoscopy.includes(code) && colonoscopyDoc) {
      // console.log("Code received:", code);

      data.documentName = getDocName(colonoscopyDoc);
      data.eventKey = 69;
    } else if (docMap.anaesthetic.includes(code) && anaestheticDoc) {
      // console.log("Code received:", code);

      data.documentName = getDocName(anaestheticDoc);
      data.eventKey = 67;
    } else if (
      docMap.patient_clinical?.includes(code) &&
      patientClinicalNotesDoc
    ) {
      data.documentName = getDocName(patientClinicalNotesDoc);
      data.eventKey = 136;
    } else if (
      docMap.operative_report?.includes(code) &&
      operativeReportTotalKneeArthroplastyDoc
    ) {
      data.documentName = getDocName(operativeReportTotalKneeArthroplastyDoc);
      data.eventKey = 134;
    } else if (
      docMap.discharge_summary?.includes(code) &&
      dischargeSummaryDoc
    ) {
      data.documentName = getDocName(dischargeSummaryDoc);
      data.eventKey = 128;
    } else {
      console.warn("No matching document found for code:", code);
      return;
    }

    sessionStorage.setItem("documentViewerData", JSON.stringify(data));
    window.open("/document-viewer", "_blank");
  };

  const handleReferenceClick = (code, reasoningId) => {
    setSourceLoading(true);
    codeReferenceClick(code, reasoningId)
      .then((res) => {
        const fileUrl = res?.data?.download_url;
        const filename = fileUrl.split("/").pop().split("?")[0];
        fetch(fileUrl)
          .then((response) => response.text())
          .then((data) => {
            const newWindow = window.open("", "_blank");
            if (newWindow) {
              newWindow.document.body.innerHTML = `<pre>${data}</pre>`;
            } // Display content inside <pre> tag
            newWindow.document.title = filename;
          })
          .catch((error) => console.error("Error fetching file:", error));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSourceLoading(false);
      });
  };
  const hasAnyAICode = () => {
    if (!codingscreendata?.data) return false;

    const allCodes = [
      ...(codingscreendata.data.principal_diagnosis || []),
      ...(codingscreendata.data.additional_diagnoses || []),
      ...(codingscreendata.data.procedure_codes || []),
    ];

    return allCodes.some((codeItem) => codeItem.origin === "AI");
  };
  // };
  const ISAIORIGINEYEICON = item.origin === "AI"
  const isAIOrigin = item.origin === "AI" && isAwaitingValidation;
  const isProviderOrUser = item.origin === "P" || item.origin === "U";
  const isOnlyUser = item.origin === "U";
  const isOnlyUserAudited = item.origin === "AU";
  const inScope = item.code_type === "In scope";
  const partialScope = item.code_type === "Partial";
  const outOffScopScope = item.code_type === "Out Off scope";
  // console.log(isAIOrigin,ISAIORIGINEYEICON,"iufhufi");

  const shouldShowAccept = isAIOrigin;
  const shouldShowDelete = isAIOrigin || isProviderOrUser;
  const shouldShowSource = isAIOrigin;
  const shouldShowCodebook = isAIOrigin || isProviderOrUser;
  // console.log(drgConfirmedStatusUpdate,"see");

  const handleDescriptionTap = () => {
    if (isTouchDevice) {
      setOpen(true);
      // Auto-close after a short time (e.g., 2 seconds)
      setTimeout(() => setOpen(false), 2000);
    }
  };
  const handleCodeTap = () => {
    // console.log("hjgfhjkhgfcxghjkhgcv");

    if (isTouchDevice) {
      setCodeOpen(true);
      // Auto-close after a short time (e.g., 2 seconds)
      setTimeout(() => setCodeOpen(false), 2000);
    }
  };
  const handleViewAIJustification = () => {
  const evidence = item?.evidence?.trim() ?? "";
  const documentName = item?.document_name?.trim() ?? "";

  // No evidence and no document
  if (!evidence && !documentName) {
    toast.error("AI evidence and document are not available.");
    return;
  }

  const aiData = {
    code: item?.code ?? "",
    justification: item?.justification ?? "",
    evidence,
    document_name: documentName,
  };

  reduxDispatch(setAIJustificationData(aiData));
  reduxDispatch(setDocumentationCard(true));

  console.log("AI Justification stored:", aiData);
};
//   const handleViewAIJustification = () => {
//   const aiData = {
//     code: item?.code ?? "",
//     justification: item?.justification ?? "",
//     evidence: item?.evidence ?? "",
//     document_name: item?.document_name ?? "",
//   };

//   reduxDispatch(setAIJustificationData(aiData));

//   console.log("AI Justification stored:", aiData);
// };

  //   useEffect(() => {
  //     const alphabetIDs = Array.from({ length: 26 }, (_, i) =>
  //       String.fromCharCode(65 + i)
  //     );
  //     const doubleAlphabetIDs = alphabetIDs.map((ch) => ch + ch);
  //     const allClusterIDs = [...alphabetIDs, ...doubleAlphabetIDs];

  //     reduxDispatch(setClusterIDs(allClusterIDs));
  //     const usedClusters = [
  //   ...(diagnosisStates?.principal ?? []).map(i => i?.code?.[0]),
  //   ...(diagnosisStates?.additional ?? []).map(i => i?.code?.[0]),
  // ].filter(Boolean);

  //     const uniqueUsedClusters = [...new Set(usedClusters)];

  //     const nextCluster = allClusterIDs.find(
  //       (id) => !uniqueUsedClusters.includes(id)
  //     );

  //     if (nextCluster) {
  //       reduxDispatch(setcurrentClusterID(nextCluster));
  //     }

  //   }, [diagnosisStates]);
  const getBaseCode = (fullCode) => {
    if (!fullCode) return '';
    // If is_DCID is true, remove first 2 characters (cluster ID + COF)
    // If is_DCID is false, remove only first character (just cluster ID)
    return isDCID ? fullCode.substring(2) : fullCode.substring(1);
  };

  // Helper function to get COF from code
  const getCOF = (fullCode) => {
    if (!fullCode) return '';
    return isDCID ? fullCode.charAt(1) : fullCode.charAt(0);
  };

  // Helper function to get cluster ID from code
  const getClusterID = (fullCode) => {
    if (!fullCode) return '';
    return isDCID ? fullCode.charAt(0) : fullCode.charAt(0);
  };
const onClusterIDChange = (word, type, code) => {
    if (code?.charAt(0) === "0") {
      toast.warning(
        "All supplementary codes for chronic conditions should have a chronic condition cluster ID of 0",
      );
      return;
    }
    if (Number(word) === 0) {
      toast.warning(
        "All supplementary codes for chronic conditions should have a chronic condition cluster ID of 0",
      );
      return;
    }

    const currentCOF = getCOF(code);
    const baseCodeWithoutClusterAndCOF = getBaseCode(code);
    
    const newCode = isDCID 
      ? word + currentCOF + baseCodeWithoutClusterAndCOF
      : word + baseCodeWithoutClusterAndCOF;
    
    // Check if the new cluster ID already exists with the same code and COF
    const sectionsToCheck = ['principal', 'additional'];
    let duplicateFound = false;
    let duplicateSection = null;
    let duplicateDetails = null;
    
    sectionsToCheck.forEach(section => {
      if (diagnosisStates[section] && Array.isArray(diagnosisStates[section])) {
        diagnosisStates[section].forEach(item => {
          if (item.code === code) return;
          
          const itemCOF = getCOF(item.code);
          const itemClusterID = getClusterID(item.code);
          const itemBaseCode = getBaseCode(item.code);
          
          // Only check if the base code matches AND the cluster ID matches the new one
          if (itemBaseCode === baseCodeWithoutClusterAndCOF && itemClusterID === word) {
            duplicateFound = true;
            duplicateSection = section;
            duplicateDetails = {
              existingCode: item.code,
              existingCOF: itemCOF,
              existingClusterID: itemClusterID
            };
          }
        });
      }
    });

    if (duplicateFound) {
      toast.warning(
        `The code "${baseCodeWithoutClusterAndCOF}" already exists in ${duplicateSection === 'principal' ? 'Principal' : 'Additional'} diagnoses with cluster ID "${word}" and COF "${duplicateDetails.existingCOF}". Please choose a different cluster ID.`
      );
      return;
    }

    reduxDispatch(setcurrentClusterID(word));

    setDiagnosisStates((prevStates) => {
      const updatedStates = {
        principal: [...prevStates.principal],
        additional: [...prevStates.additional],
        procedure: [...prevStates.procedure],
      };

      const foundIndex = updatedStates[type]?.findIndex(
        (item) => item.code === code,
      );

      if (foundIndex !== -1) {
        const foundItem = { ...updatedStates[type][foundIndex] };
        foundItem.code = newCode;
        updatedStates[type][foundIndex] = foundItem;
      }
      return updatedStates;
    });
    onCofOrClusterChange?.();
  };
 const handleDropdownOpen = (currentCode) => {
  const currentChar = currentCode?.charAt(0)?.toUpperCase() || "";

  if (!currentChar) return [];

  let addedCommonIdsWithNextFive = [];

  if (currentChar === "0" || currentChar === "8") {
    // Use the latest selected alphabet
    const highestAlphabet =
      currentClusterID &&
      currentClusterID !== "0" &&
      currentClusterID !== "8"
        ? currentClusterID.toUpperCase()
        : [...clusterIDs].filter((c) => isNaN(c)).pop();

    const charCode = highestAlphabet.charCodeAt(0);

    const alphabetOptions = [];

    // A -> highest alphabet
    for (let i = 65; i <= charCode; i++) {
      alphabetOptions.push(String.fromCharCode(i));
    }

    // next 5 letters
    for (let i = 1; i <= 5; i++) {
      alphabetOptions.push(String.fromCharCode(charCode + i));
    }

    addedCommonIdsWithNextFive =
      currentChar === "0"
        ? [...alphabetOptions, "8"]
        : [...alphabetOptions, "0"];
  } else {
    const currentIndex = clusterIDs.indexOf(currentChar);

    const prevClusterIDs = clusterIDs.slice(0, currentIndex);

    const nextFive = [];

    const charCode = currentChar.charCodeAt(0);

    for (let i = 1; i <= 5; i++) {
      nextFive.push(String.fromCharCode(charCode + i));
    }

    addedCommonIdsWithNextFive = [
      ...prevClusterIDs,
      ...nextFive,
      "0",
      "8",
    ];
  }

  reduxDispatch(setNextClusterIDs(addedCommonIdsWithNextFive));
};

  // function getCofValue(item, selectedCofValues, type, index) {
  //   const val = selectedCofValues?.[type]?.[index];
  //   const fallback =
  //     ["1", "2"].includes(item?.code?.[1]) ? item?.code?.charAt(1) : item?.code?.charAt(0);
  //   return typeof val === "object" ? val?.cof ?? fallback : val ?? fallback;
  // }

  // function getCofValue(item, selectedCofValues, type, index) {
  //   let correctedType;
  //   switch(type) {
  //     case "additional":
  //       correctedType = "additional_diagnoses";
  //       break;
  //     case "principal":
  //       correctedType = "principal_diagnosis";
  //       break;
  //     case "procedure":
  //       correctedType = "procedure_codes";
  //       break;
  //     default:
  //       correctedType = type;
  //   }
  //   const selectedItem = selectedCofValues?.[correctedType]?.[index];
  //   let result;

  //   if (selectedItem) {
  //     if (typeof selectedItem === "object" && selectedItem.cof !== undefined) {
  //       result = selectedItem.cof;
  //     } else {
  //       const codeToCheck = selectedItem.code || selectedItem;
  //       result = ["1", "2"].includes(codeToCheck?.[1]) ? codeToCheck?.charAt(1) : codeToCheck?.charAt(0);
  //     }
  //   } else {
  //     result = ["1", "2"].includes(item?.code?.[1]) ? item?.code?.charAt(1) : item?.code?.charAt(0);
  //   }

  //     const isLetter = /^[A-Z]$/.test(result);
  //   const isZeroOrEight = result === "0" || result === "8";
  //   if (isLetter || isZeroOrEight) {
  //     return "2";
  //   }

  //   return result;
  // }
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  const normalizedCode = item?.code?.replace(/^[12]/, "");

  const compareCode = codebookusaEnv
    ? normalizedCode.slice(1)
    : codingscreendata?.data?.meta?.is_DCID === true
      ? normalizedCode.slice(2)
      : normalizedCode;
  const handleCodeSearchRef = (acsCode) => {
    reduxDispatch(updateAcsCode(null));
    setTimeout(() => {
      reduxDispatch(updateAcsCode(acsCode));
    }, 0);
    reduxDispatch(setActiveTab("Australian Coding Standard"));
    reduxDispatch(setActiveIcon("Coding"));
  };
  const handleNationalSearchRef = (ncaCode) => {
    reduxDispatch(updateNcaCode(null));
    setTimeout(() => {
      reduxDispatch(updateNcaCode(ncaCode));
    }, 0);
    reduxDispatch(setActiveIcon("References"));
    reduxDispatch(setActiveTab("National Coding Advice"));
  };

  return codeBookLoading ||
    (selectedCodebookVersion === "12th" && !isFetched12) ||
    (selectedCodebookVersion === "13th" && !isFetched13) ? (
    <div className="google-skeleton">
      <div className="skeleton-line"></div>
    </div>
  ) : (
    <Draggable
      key={`${type}-${item?.code}-${index}`}
      draggableId={`${type}-${item?.code}-${index}`}
      index={index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          data-diagnosis-row={type}
          data-row-index={index}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`draggable-item label-wrapper-scroll ${ snapshot.isDragging ? "dragging" : ""} ${isSelected ? "selected-row" : ""}`}
          style={provided.draggableProps.style}
        >
          <div
            className={`label-wrapper ${
            newlyInsertedCodes?.includes(type === "procedure" ? item?.code : compareCode)
            ? "newly-inserted"
            : ""
          }`}
            style={{
              fontWeight: isCodingComplete
                ? "normal"
                : accepted?.[item?.code]
                  ? "normal"
                  : isAIOrigin
                    ? "bold"
                    : "normal",
color:
  isCodingComplete && visibleNudgeCount > 0
    ? outOffScopScope
      ? "red"
      : inScope
        ? "green"
        : partialScope
          ? "orange"
          : "black"
    : isCodingComplete
      ? "black"
      : location.pathname === "/coder"
        ? outOffScopScope
          ? "red"
          : inScope
            ? "green"
            : partialScope
              ? "orange"
              : "inherit"
        : isOnlyUserAudited || isOnlyUser
          ? "#2f759e"
          : "inherit",
            }}
          >
            <img
              src={bar_icon}
              alt="threeline"
              style={{ paddingLeft: "12px" }}
            />
            <span
              style={{
                minWidth: "26px",
                textAlign: "center",
                fontWeight: "600",
                fontSize: "13px",
                color: "#555",
                paddingLeft: "6px",
                paddingRight: "2px",
              }}
            >
              {displayNumber ?? index + 1}
            </span>

            {type !== "procedure" && (
              <>
                {!codebookusaEnv &&
                  item?.code &&
                  ["1", "2"].includes(item?.code[1]) && (
                    <Dropdown
                      className="codingscreen-cludter-ids-dropdown"
                      onToggle={(isOpen) => {
                        if (isOpen) {
                          handleDropdownOpen(item?.code);
                        }
                      }}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        style={{
                          backgroundColor: (() => {
                            const code = item?.code;
                            if (!code) return "";

                            const first = code[0].toUpperCase();
                            if (first === "0") return "#0059ffff";
                            if (first === "8") return "#f63e3bff";
                            if (/^[A-Z]$/.test(first)) return "#22c52dff";
                            return "#E5E7EB";
                          })(),
                          color: "white",
                          fontWeight: "700",
                        }}
                      >
                        {item?.code
                          ? item?.code && ["1", "2"]?.includes(item.code[1])
                            ? item?.code[0]
                            : item?.code[1] || currentClusterID
                          : ""}
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="my-actions-dropdown"
                        renderOnMount
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        style={{ zIndex: 9999 }}
                      >
                        {nextClusterIDs?.length > 0 ? (
                          nextClusterIDs?.map((word) => (
                            <Dropdown.Item
                              key={word}
                              onClick={() =>
                                onClusterIDChange(word, type, item?.code)
                              }
                            >
                              {word}
                            </Dropdown.Item>
                          ))
                        ) : (
                          <Dropdown.Item disabled>
                            No more clusters
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                <Dropdown className="codingscreen-dropdown" >
                  <Dropdown.Toggle variant="light">
                    {/* {getCofValue(item, selectedCofValues, type, index)} */}
                    {typeof selectedCofValues[type]?.[index] === "object"
                      ? selectedCofValues[type]?.[index]?.cof
                      : (selectedCofValues[type]?.[index] ??
                        (item?.code && ["1", "2"]?.includes(item?.code[1])
                          ? item?.code?.charAt(1)
                          : item?.code?.charAt(0)))}
                  </Dropdown.Toggle>

                  {
                    <Dropdown.Menu
                      className="my-actions-dropdown"
                      renderOnMount
                      popperConfig={{
                        strategy: "fixed",
                      }}
                      style={{ zIndex: 9999 }}
                    >
                      {(codebookusaEnv ? [1, "Y", "N", "U", "W"] : [1, 2])?.map(
                        (num) => (
                          <Dropdown.Item
                            key={num}
                            onClick={() =>
                              handleCofSelect(type, index, num, item?.code)
                            }
                          >
                            {num}
                          </Dropdown.Item>
                        ),
                      )}
                    </Dropdown.Menu>
                  }
                </Dropdown>
              </>
            )}
            <Tooltip
              title={
                hacStatus[getBaseCode(item?.code)] &&
                "This is Hospital Acquired Complication"
              }
            >
              <div style={{ width: "22px", height: "27px" }}>
                {hacStatus[getBaseCode(item?.code)] && (
                  <span className="hac-label">H</span>
                )}
              </div>
            </Tooltip>

            <Tooltip
              title={
                type === "procedure"
                  ? item?.code
                  : item?.code
                    ? ["1", "2"].includes(item?.code[1])
                      ? item?.code?.slice(2)
                      : item?.code?.slice(1)
                    : ""
              }
              open={isTouchDevice ? codeOpen : undefined}
              disableHoverListener={isTouchDevice}
              disableTouchListener
            >
              <span className="code-name" onClick={handleCodeTap}>
                {type === "procedure"
                  ? item?.code
                  : item?.code
                    ? ["1", "2"].includes(item?.code[1])
                      ? item?.code?.slice(2)
                      : item?.code?.slice(1)
                    : ""}
              </span>
            </Tooltip>
            <Tooltip
              title={item.description}
              open={isTouchDevice ? open : undefined}
              disableHoverListener={isTouchDevice}
              disableTouchListener
            >
              <span className="code-description" onClick={handleDescriptionTap}>
                {item.description}
              </span>
            </Tooltip>
            {/* {mockLabels.map((item) => {
              return <span className="reference-label" onClick={()=>setPopupData(true)} key={item}>{item.labels}</span>;
            })} */}
            {/* Conditionally render icons based on origin */}
            {/* {location.pathname !== "/Code-Assist" ? ( */}

            <div className="d-flex gap-2 ms-auto coding-action-icons">
              <div
                className={`draggable-item-acs ${item.acs ? "has-acs" : ""}`}
              >
                {item.acs && (
                  <button
                    className={`acs-btn ms-2 ${item.origin !== "AI" && hasAnyAICode() ? "not-ai" : ""}`}
                    onClick={() => handleCodeSearchRef(item.acs)}
                  >
                    ACS
                  </button>
                )}
              </div>
              <div
                className={`draggable-item-acs-nca ${item.nac || item.acs ? "has-acs" : ""}`}
              >
                {item.nca && (
                  <button
                    className={`nca-btn  ${item.origin !== "AI" && hasAnyAICode() ? "not-ai" : ""}`}
                    onClick={() => handleNationalSearchRef(item.nca)}
                  >
                    Advice
                  </button>
                )}
              </div>
                  {type === "procedure" && !achiCodesData?.achiCodes.includes(item?.code) && (
   <>
              <div
                onClick={() => {
                  reduxDispatch(setIsProcedureCodeCopyModal(true))
                  reduxDispatch(setProcedureCodeItem(item))
                }}
              >
                <ContentCopyIcon   sx={{ color: "#bebebe", cursor: "pointer", fontSize: "14px" }} /> 
              </div>
              </>
)}
               
              {shouldShowAccept &&
                !accepted?.[item.code] &&
                !(
                  drgConfirmedStatus === "Coding Complete" ||
                  drgConfirmedStatus === "Audited" ||
                  drgConfirmedStatus === "Awaiting Audit" ||
                  drgConfirmedStatus === "Audit - Awaiting Audit" ||
                  drgConfirmedStatusUpdate
                ) && (
                  <Tooltip title="Accept Code">
                    <img
                      src={accept_icon}
                      alt="Accept"
                      onClick={() => handleAcceptCodes(item.code)}
                    />
                  </Tooltip>
                )}

              {iconDisplay ? (
                <>
                  <Tooltip title="Delete Code">
                    <img
                      src={delete_icon}
                      alt="Delete"
                      onClick={() => handleDelete(type, index)}
                    />
                  </Tooltip>
                    {ISAIORIGINEYEICON &&
                    !["/Code-Assist", "/Auditor-CodeAssist-Screen"].includes(location.pathname)&& (
  <Tooltip title="View AI Justification">
    <img
      src={eyeIcon}
      alt="View AI Justification"
      onClick={handleViewAIJustification}
      style={{ cursor: "pointer" }}
    />
  </Tooltip>
)}

                  {/* <Tooltip title="Delete Code">
                      <img
                        src={delete_icon}
                        alt="Delete"
                        onClick={() => handleDelete(type, index)}
                      />
                    </Tooltip> */}
                  <Tooltip title="View in Codebook">
                    <img
                      src={codebook_icon}
                      alt="Codebook"
                      onClick={() =>
                        handleCodebookClick(
                          type === "procedure"
                            ? item?.code
                            : ["1", "2"].includes(item?.code?.[1])
                              ? item?.code?.slice(2)
                              : item?.code?.slice(1),

                          // 2️⃣ Code type detection (same as before)
                          /^[0-9]+$/.test(item?.code)
                            ? codebookusaEnv
                              ? "CPT"
                              : "ACHI"
                            : type === "procedure"
                              ? codebookusaEnv
                                ? "PCS"
                                : "ACHI"
                              : "ICD",
                        )
                      }
                    />
                  </Tooltip>
                </>
              ) : (
                <>
                  {shouldShowDelete && (
                    <Tooltip title="Delete Code">
                      <img
                        src={delete_icon}
                        alt="Delete"
                        onClick={() => handleDelete(type, index)}
                      />
                    </Tooltip>
                  )}
                  {shouldShowCodebook && (
                    <Tooltip title="View in Codebook">
                      <img
                        src={codebook_icon}
                        alt="Codebook"
                        onClick={() =>
                          handleCodebookClick(
                            type === "procedure"
                              ? item?.code
                              : ["1", "2"].includes(item?.code?.[1])
                                ? item?.code?.slice(2)
                                : item?.code?.slice(1),
                            /^[0-9]+$/.test(item?.code)
                              ? codebookusaEnv
                                ? "CPT"
                                : "ACHI"
                              : type === "procedure"
                                ? codebookusaEnv
                                  ? "PCS"
                                  : "ACHI"
                                : "ICD",
                          )
                        }
                      />
                    </Tooltip>
                  )}
                </>
              )}

              {sourceLoading ? (
                <FaSpinner />
              ) : (
                shouldShowSource && (
                  <Tooltip title="Source Document">
                    <img
                      onClick={() => getReasoningId(item?.code)}
                      src={source_doc_ref}
                      alt="Source"
                    />
                  </Tooltip>
                )
              )}
            </div>
          </div>
          {/* {popupData && <ReferencePopUp/>} */}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableItem;
